export const RDX_KNOW_DATA_FETCH = 'rdx/know/data/fetch';
export const RDX_KNOW_DATA_FETCH_DONE = 'rdx/know/data/fetch/done';
export const RDX_KNOW_DATA_FETCH_SPINNER = 'rdx/know/data/spinner/fetch';
export const RDX_KNOW_DATA_FETCH_DONE_SPINNER = 'rdx/know/data/spinner/fetch/done';
export const RDX_KNOW_DATA_CLEAN = 'rdx/know/data/clean';
export const RDX_KNOW_DATA_FETCH_ERR = 'rdx/know/data/fetch/error';
export const RDX_KNOW_DATA_FETCH_ERR_SPINNER = 'rdx/know/data/fetch/error';
export const RDX_KNOW_RESULT_FETCH = 'rdx/know/result/fetch';
export const RDX_KNOW_RESULT_FETCH_DONE = 'rdx/know/result/fetch/done';
export const RDX_KNOW_RESULT_FETCH_ERR = 'rdx/know/result/fetch/error';
export const RDX_KNOW_RESULT_FETCH_SPINNER = 'rdx/know/result/spinner/fetch';
export const RDX_KNOW_RESULT_FETCH_DONE_SPINNER = 'rdx/know/result/spinner/fetch/done';
export const RDX_KNOW_RESULT_FETCH_ERR_SPINNER = 'rdx/know/result/spinner/fetch/error';
export const RDX_KNOW_NEXT_STEP_FETCH = 'rdx/know/next/step/fetch';
export const RDX_KNOW_NEXT_STEP_FETCH_SPINNER = 'rdx/know/next/spinner/step/fetch';
export const RDX_KNOW_DATA_SAVE = 'rdx/know/data/save';
export const RDX_KNOW_DATA_SAVE_DONE = 'rdx/know/data/save/done';
export const RDX_KNOW_DATA_SAVE_ERR = 'rdx/know/data/save/error';
export const RDX_KNOW_DATA_SAVE_SPINNER = 'rdx/know/data/spinner/save';
export const RDX_KNOW_DATA_SAVE_DONE_SPINNER = 'rdx/know/data/spinner/save/done';
export const RDX_KNOW_DATA_SAVE_ERR_SPINNER = 'rdx/know/data/spinner/save/error';
export const RDX_KNOW_DATA_UPDATE = 'rdx/know/data/update';
export const RDX_KNOW_DATA_UPDATE_DONE = 'rdx/know/data/update/done';
export const RDX_KNOW_DATA_UPDATE_ERR = 'rdx/know/data/update/error';
export const RDX_KNOW_DATA_UPDATE_SPINNER = 'rdx/know/data/spinner/update';
export const RDX_KNOW_DATA_UPDATE_DONE_SPINNER = 'rdx/know/data/spinner/update/done';
export const RDX_KNOW_DATA_UPDATE_ERR_SPINNER = 'rdx/know/data/spinner/update/error';
export const RDX_KNOW_PARAMS_FETCH = 'rdx/know/params/fetch';
export const RDX_KNOW_PARAMS_UPDATE_FETCH = 'rdx/know/params/update/fetch';
export const RDX_KNOW_BACK_PARAMS_FETCH = 'rdx/know/back/params/fetch';
export const RDX_KNOW_UPLOAD_CERTIFICATE = 'rdx/know/upload/certificate';
export const RDX_KNOW_UPLOAD_CERTIFICATE_DONE = 'rdx/know/upload/certificate/done';
export const RDX_KNOW_UPLOAD_CERTIFICATE_ERR = 'rdx/know/upload/certificate/error';
export const RDX_KNOW_SCORES_FETCH = 'rdx/know/score/fetch';
export const RDX_KNOW_SCORES_FETCH_DONE = 'rdx/know/score/fetch/done';
export const RDX_KNOW_SCORES_FETCH_SPINNER = 'rdx/know/score/spinner/fetch';
export const RDX_KNOW_SCORES_FETCH_DONE_SPINNER = 'rdx/know/score/spinner/fetch/done';
export const RDX_KNOW_DATA_GET_ERROR = 'rdx/know/data/get/error';
export const RDX_KNOW_DATA_GET_ERROR_SPINNER = 'rdx/know/data/spinner/get/error';
export const RDX_KNOW_DATA_SPINNER_LOADING_START = 'rdx/know/spinner/loading/start';
export const RDX_KNOW_DATA_SPINNER_LOADING_END = 'rdx/know/spinner/loading/end';

export const startSpinnerAPI = (request, params) => {
  return {
    type: RDX_KNOW_DATA_SPINNER_LOADING_START,
    data: request,
    params: params,
  };
};

export const endSpinnerAPI = (request, params) => {
  return {
    type: RDX_KNOW_DATA_SPINNER_LOADING_END,
    data: request,
    params: params,
  };
};

export const getKnowData = (request, params) => {
  return {
    type: RDX_KNOW_DATA_FETCH,
    data: request,
    params: params,
  };
};

export const getKnowDataDone = (data) => {
  return {
    type: RDX_KNOW_DATA_FETCH_DONE,
    data: data,
  };
};

export const getDataErrorInfo = (errorInfo) => {
  return {
    type: RDX_KNOW_DATA_GET_ERROR,
    errorInfo: errorInfo,
  };
};

export const getKnowDataSpinner = (request, params) => {
  return {
    type: RDX_KNOW_DATA_FETCH_SPINNER,
    data: request,
    params: params,
  };
};

export const getKnowDataDoneSpinner = (data) => {
  return {
    type: RDX_KNOW_DATA_FETCH_DONE_SPINNER,
    data: data,
  };
};

export const getDataErrorInfoSpinner = (errorInfo) => {
  return {
    type: RDX_KNOW_DATA_GET_ERROR_SPINNER,
    errorInfo: errorInfo,
  };
};

export const getKnowScores = (request, params) => {
  return {
    type: RDX_KNOW_SCORES_FETCH,
    data: request,
    params: params,
  };
};

export const getKnowScoresDone = (data) => {
  return {
    type: RDX_KNOW_SCORES_FETCH_DONE,
    data: data,
  };
};

export const getKnowScoresSpinner = (request, params) => {
  return {
    type: RDX_KNOW_SCORES_FETCH_SPINNER,
    data: request,
    params: params,
  };
};

export const getKnowScoresDoneSpinner = (data) => {
  return {
    type: RDX_KNOW_SCORES_FETCH_DONE_SPINNER,
    data: data,
  };
};

export const cleanKnowList = () => {
  return {type: RDX_KNOW_DATA_CLEAN};
};

export const getKnowParams = (params, groupCodes, knowResult) => {
  console.log('params', params, groupCodes);
  return {
    type: RDX_KNOW_PARAMS_FETCH,
    params: params,
    groupCodes: groupCodes,
    knowResult: knowResult,
  };
};

export const updateKnowParams = (params) => {
  return {
    type: RDX_KNOW_PARAMS_UPDATE_FETCH,
    params: params,
  };
};

export const getKnowBackParams = (params) => {
  return {
    type: RDX_KNOW_BACK_PARAMS_FETCH,
    params: params,
  };
};

export const getKnowResult = (request, params) => {
  return {
    type: RDX_KNOW_RESULT_FETCH,
    data: request,
    params: params,
  };
};

export const getKnowResultDone = (data) => {
  return {
    type: RDX_KNOW_RESULT_FETCH_DONE,
    data: data,
  };
};

export const getKnowNextStep = (request, params) => {
  return {
    type: RDX_KNOW_NEXT_STEP_FETCH,
    data: request,
    params: params,
  };
};

export const getKnowNextStepSpinner = (request, params) => {
  return {
    type: RDX_KNOW_NEXT_STEP_FETCH_SPINNER,
    data: request,
    params: params,
  };
};

export const saveKnowData = (data) => {
  return {
    type: RDX_KNOW_DATA_SAVE,
    data: data,
  };
};

export const saveKnowDataDone = (data) => {
  return {
    type: RDX_KNOW_DATA_SAVE_DONE,
    data: data,
  };
};

export const saveKnowDataErr = (data, errorInfo) => {
  return {
    type: RDX_KNOW_DATA_SAVE_ERR,
    data: data,
    errorInfo: errorInfo,
  };
};

export const saveKnowDataSpinner = (data) => {
  return {
    type: RDX_KNOW_DATA_SAVE_SPINNER,
    data: data,
  };
};
export const saveKnowDataDoneSpinner = (data) => {
  return {
    type: RDX_KNOW_DATA_SAVE_DONE_SPINNER,
    data: data,
  };
};

export const saveKnowDataErrSpinner = (data, errorInfo) => {
  return {
    type: RDX_KNOW_DATA_SAVE_ERR_SPINNER,
    data: data,
    errorInfo: errorInfo,
  };
};

export const updateKnowData = (data) => {
  return {
    type: RDX_KNOW_DATA_UPDATE,
    data: data,
  };
};

export const updateKnowDataDone = (data) => {
  return {
    type: RDX_KNOW_DATA_UPDATE_DONE,
    data: data,
  };
};

export const updateKnowDataErr = (data, errorInfo) => {
  return {
    type: RDX_KNOW_DATA_UPDATE_ERR,
    data: data,
    errorInfo: errorInfo,
  };
};

export const updateKnowDataSpinner = (data) => {
  return {
    type: RDX_KNOW_DATA_UPDATE_SPINNER,
    data: data,
  };
};

export const updateKnowDataDoneSpinner = (data) => {
  return {
    type: RDX_KNOW_DATA_UPDATE_DONE_SPINNER,
    data: data,
  };
};

export const updateKnowDataErrSpinner = (data, errorInfo) => {
  return {
    type: RDX_KNOW_DATA_UPDATE_ERR_SPINNER,
    data: data,
    errorInfo: errorInfo,
  };
};

export const uploadCertificate = (data) => {
  return {
    type: RDX_KNOW_UPLOAD_CERTIFICATE,
    data: data,
  };
};

export const uploadCertificateDone = (data) => {
  return {
    type: RDX_KNOW_UPLOAD_CERTIFICATE_DONE,
    data: data,
  };
};

export const uploadCertificateErr = (data, errorInfo) => {
  return {
    type: RDX_KNOW_UPLOAD_CERTIFICATE_ERR,
    data: data,
    errorInfo: errorInfo,
  };
};
